var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10.8892V15.81C17.5 16.7433 16.7492 17.5 15.8225 17.5H4.1775C3.25083 17.5 2.5 16.7433 2.5 15.81V5.02334C2.5 4.09 3.25083 3.33334 4.1775 3.33334H10",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52344 14.31L9.6326 13.5325C9.77927 13.4958 9.9126 13.42 10.0201 13.3133L17.0118 6.32167C17.6626 5.67083 17.6626 4.61583 17.0118 3.965L16.8684 3.82167C16.2176 3.17083 15.1626 3.17083 14.5118 3.82167L7.5201 10.8133C7.41344 10.92 7.3376 11.0542 7.30094 11.2008L6.52344 14.31",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1914 5.14167L15.6914 7.64167",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62202 13.535C9.63368 13.4467 9.64868 13.3592 9.64868 13.2675C9.64868 12.1167 8.71618 11.1842 7.56535 11.1842C7.47368 11.1842 7.38618 11.2 7.29785 11.2108",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.8f1c2976eb98bcd09d7efbc21a6ecc9c.svg";
export { ForwardRef as ReactComponent };